import { boot } from 'quasar/wrappers'
// import firebase from 'firebase'
import { initializeApp } from 'firebase/app';
import { getAuth } from "firebase/auth";
import { useInvitationStore } from '../stores/invitation'
import { useAppsumoStore } from '../stores/appsumo'

const firebaseConfig = {
  "apiKey": "AIzaSyDEzFBwkkpgkLyhtaUH8I0jOJB3jnIQ6MY",
  "authDomain": "form-data-ebefd.firebaseapp.com",
  "databaseURL": "https://form-data-ebefd.firebaseio.com",
  "projectId": "form-data-ebefd",
  "storageBucket": "form-data-ebefd.appspot.com",
  "messagingSenderId": "1047836896961",
  "appId": "1:1047836896961:web:b6e8d24fa3374ecf8a2e40",
  "measurementId": "G-364M7SQVP6"
};

// "async" is optional;
// more info on params: https://v2.quasar.dev/quasar-cli/boot-files
export default boot(async ({ router }) => {
  initializeApp(firebaseConfig);
  const auth = getAuth();
  router.beforeEach((to, from, next) => {
    return new Promise((resolve, reject) => {
      const unsubscribe = auth.onAuthStateChanged(function (user) {
        unsubscribe();
        if (to.query.inv) {
          const invitationStore = useInvitationStore()
          invitationStore.init(to.query.inv)
          next(to.path)
          return resolve(user);
        }
        if (to.query.appsumo_license_key) {
          const appsumoStore = useAppsumoStore()
          appsumoStore.init(to.query.appsumo_license_key)
          next(to.path)
          return resolve(user);
        }
        // Store the original path for OAuth flows to redirect back after login
        if (to.path.includes('/oauth/authorize') && !user) {
          // Store the original request including query parameters
          sessionStorage.setItem('oauthRedirect', JSON.stringify({
            path: to.fullPath,
            query: to.query
          }));
        }

        if (!user && to.path !== "/auth/login" && to.path !== "/auth/signup" && to.path !== "/auth/reset-password") {
          next("/auth/login");
          return resolve(user);
        } else if (user) {
          // if (!user.emailVerified && to.path != "/auth/verifyEmail" && to.path != "/auth/completeAccount") {
          //   next("/auth/verifyEmail");
          // } else
          if (to.path === '/auth/login' || to.path === "/auth/verifyEmail" || to.path === "/auth/completeAccount") {
            next("/");
            return resolve(user);
          } else {
            // Check if we have a pending invitation
            const invitationStore = useInvitationStore()
            if (invitationStore.invitationToken && to.path !== "/auth/acceptInvite") {
              next('/auth/acceptInvite')
              return resolve(user);
            }

            const appsumoStore = useAppsumoStore()
            if (appsumoStore.licenseKey && to.path !== "/auth/assignAppsumoLicense") {
              next('/auth/assignAppsumoLicense')
              return resolve(user);
            }

            // Check if we have a stored OAuth redirect
            const oauthRedirect = sessionStorage.getItem('oauthRedirect');
            if (oauthRedirect) {
              const redirectData = JSON.parse(oauthRedirect);
              sessionStorage.removeItem('oauthRedirect'); // Clear the stored redirect
              next(redirectData.path);
              return resolve(user);
            }
            next()
            return resolve(user);
          }
        } else {
          next();
          return resolve(user);
        }
      }, reject)
    });
  })
})
